import { api } from '../index';

export const register = data => api.post('/register', data);

export const googleAuth = data => api.post('/auth/google', data);

export const googleAuthCheck = params => api.get('/auth/google/check', { params });

export const login = data => api.post('/oauth/token', data);

export const requestResetPassword = data => api.post('/password/create', data);

export const resetPasswordIsValidToken = token => api.get(`/password/find/${token}`);

export const resetPassword = data => api.post('/password/reset', data);

export const verifyToken = token => api.post(`/confirm/${token}`);

export const getQrMsCode = () => api.get('/two-factor');

export const activeTwoFactor = data => api.post('/two-factor/activate', data);

export const disableTwoFactor = data => api.post('two-factor/disable', data);

export const registerWizard = data => api.post('/register-wizard', data);

export const registerWizardSetPassword = (data, token) => api.post(`/register-wizard/confirm/${token}`, data);
